import { useEffect } from 'react';

import { getHomeLenis } from './useHomeSmoothScroll';

interface BodyStyleSnapshot {
  left: string;
  overflow: string;
  paddingRight: string;
  position: string;
  right: string;
  top: string;
  width: string;
}

let activeLockCount = 0;
let lockedScrollTop = 0;
let bodyStyleSnapshot: BodyStyleSnapshot | null = null;

const getDocumentScrollTop = () => {
  return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
};

const lockBodyScroll = () => {
  if (activeLockCount === 0) {
    const { body, documentElement } = document;
    const scrollbarWidth = Math.max(0, window.innerWidth - documentElement.clientWidth);

    lockedScrollTop = getDocumentScrollTop();
    bodyStyleSnapshot = {
      left: body.style.left,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
      position: body.style.position,
      right: body.style.right,
      top: body.style.top,
      width: body.style.width,
    };

    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${String(lockedScrollTop)}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';

    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${String(scrollbarWidth)}px`;
    }

    getHomeLenis()?.stop();
  }

  activeLockCount += 1;
};

const unlockBodyScroll = () => {
  activeLockCount = Math.max(0, activeLockCount - 1);

  if (activeLockCount > 0 || !bodyStyleSnapshot) {
    return;
  }

  const { body } = document;
  const nextScrollTop = lockedScrollTop;

  body.style.overflow = bodyStyleSnapshot.overflow;
  body.style.position = bodyStyleSnapshot.position;
  body.style.top = bodyStyleSnapshot.top;
  body.style.left = bodyStyleSnapshot.left;
  body.style.right = bodyStyleSnapshot.right;
  body.style.width = bodyStyleSnapshot.width;
  body.style.paddingRight = bodyStyleSnapshot.paddingRight;

  bodyStyleSnapshot = null;
  lockedScrollTop = 0;
  getHomeLenis()?.start();
  window.scrollTo(0, nextScrollTop);
};

const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked || typeof document === 'undefined') {
      return undefined;
    }

    lockBodyScroll();

    return () => {
      unlockBodyScroll();
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
